<div class="content">
    <mat-card class="example-card">
        <mat-card-header>
            <mat-card-title>Please contact to Administrator.</mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <p>
                No Permissions given to your role. 
            </p>
        </mat-card-content>
    </mat-card>
</div>
